var BottomTxtUIModel = require('./uiModel'),
    BottomTextEl = require('./bottomTextEl'),
    RaphaelView = require('raphaelItemView'),
    Raphael = require('raphael');

require('arial');


var instanceVars = {
    parent: null, // the parent shape
    uiModel: null, // BottomTxtUIModel (set on init)

    /* for use in positioning */
    oSigBox: undefined,
    oBox: undefined
};

// note this is for new, unsaved signatures,
// ...others already persisted are attached directly to signature path,
// ( just as this will be when saved )

module.exports = RaphaelView.extend({

    initialize: function(options) {

        _.extend( this, instanceVars, _.pick(options, 'parent'), {
            uiModel:  new BottomTxtUIModel([], {
                color: this.options.parent.el.attr('fill')
            })
        });

        this.bindEntityEvents(this.parent, this.parentSubs);
    },

    parentSubs: {
        'signature.repositionBottomText':       '_position', // handles scale changes
        'signature.moveOrResizeEnd':            'moveOrResizeEnd',
        'signature.noteConsultGroupChange':     'noteConsultGroupChange'
    },

    // (from toggle) -- if from model, it's derived and appended to the other path -- this shape is never created;
    //note: never adjusting for scale of the paper -- the size of the derived shape should always be be the same
    render: function() {

        var box = this.parent.el.getBBox(),
            uim = this.uiModel,

            el = BottomTextEl( this.parent.el.paper , {
                x: box.x + uim.get('paddingX'),  //coord relative to bottom left of parent (top left of this),
                y: box.y2 + uim.get('paddingY'),
                cUsr: this.options.pgNoteModel.get('creationUserDesc'),
                cTime: null, /* indicates new */

                font: uim.get('font'),
                fontSize: uim.get('fontSize'),
                attrs: uim.get('attrs') /* INCLUDES the necessary shape type attr !!! */
        });

        this.setElement(el); // do here, or el is made a jq obj
        this.triggerMethod('afterRender'); // not a shape
        return this;

    },
    onAfterRender: function() {
        this._setOBoxValues();
        this._position(this.oSigBox);  //in case if over the bounds
    },
    _setOBoxValues: function() {
        this.oSigBox = this.parent.el.getBBox(); //TODO: put on model
        this.oBox =  this.el.getBBox();
    },
    _position: function(sigBox) {

        var ob = this.oSigBox,
            b = sigBox,
            uim = this.uiModel,
            dx = b.x -  ob.x,
            dy = b.y2 - ob.y2, //!must use the same coordinates -- it's size will change ! */
            paperBounds = this.options.channel.request('canvasContainerRel'),
            paddingY = uim.get('paddingY');

         /* primarily y -- though x can go over if shape shorter than this */
        if (ob.y2 + this.oBox.height + dy + paddingY >= paperBounds.y2) {
            var dHeight = ob.height - b.height;
            dy -= ob.height + this.oBox.height + paddingY - dHeight; //note: want relative to the parent shape -- height is fine for the first
        }
        if (this.oBox.x2 + dx >= paperBounds.x2) {
            dx = paperBounds.x2 - b.x2 - b.width + dx;  //note: really show stop to shape from moving more when boundary hit
        }
        this.el.transform('T' + dx + ',' + dy);   //(no bake for performance )
    },
    moveOrResizeEnd: function() {
        this.el.bakeTransform();
        this._setOBoxValues();
    },
    //counter-intuitive, but store in case needed later (not even using now except on initial render)
    noteConsultGroupChange: function(color) {
        this.uiModel.setColor(color);
        this.el.attr('fill', color);
    },
    onBeforeDestroy: function() {

        this.unbindEntityEvents(this.parent, this.parentSubs);
        this.el.remove(); //wanted here --- show really be done on after re-rendered ... ?
        this.uiModel.destroy();

    }

});





/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/signature/bottomText/bottomText.js
 ** module id = 220
 ** module chunks = 0
 **/